<template>
  <div>
    <v-card class="mt-2">
      <v-card-subtitle class="pb-0">
        <div class="title pa-2 blue--text text--darken-4">
          {{ $t("userWithoutAccessProfile") }}
        </div>
        <v-divider></v-divider>
      </v-card-subtitle>
      <v-card-text class="ma-2">
        <div>
          {{ $t("requestAccessFromAdministrator") }} <br>
          <template v-if="sisbraipUrl">
            {{ sisbraipMessagePrefix }}
            <a :href="sisbraipUrl" target="_blank" rel="noopener noreferrer">
              {{ sisbraipUrl }}
            </a>
          </template>
          <template v-else>
            {{ sisbraipMessage }}
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const URL_REGEX = /https?:\/\/\S+/;

export default {
  computed: {
    sisbraipMessage() {
      return this.$t("requestAccessFromSisbraipUser");
    },
    sisbraipUrl() {
      const match = this.sisbraipMessage.match(URL_REGEX);
      return match ? match[0] : "";
    },
    sisbraipMessagePrefix() {
      return this.sisbraipUrl
        ? this.sisbraipMessage.replace(this.sisbraipUrl, "")
        : this.sisbraipMessage;
    },
  },
};
</script>
